
import Vue from 'vue';
import AppButtonNew from '@/uikit/components/AppButtonNew/AppButtonNew.vue';
import Textarea from '@/pages/profile/blocks/form/components/textarea';
import { FileFieldEnum, MaxFileEnum } from '@/pages/profile/mixins';
import { File } from '@/pages/profile/blocks';

export default Vue.extend({
  name: 'ActivitiesOrderRequirements',
  components: { File, AppButtonNew, Textarea },
  props: {
    nextStep: {
      type: Function,
    },
    nextCallBack: {
      type: Function,
    },
    activity: {
      type: Object as any,
    },
  },
  data() {
    return {
      fileWarnings: '',
      file: null,
      answer: '',
    };
  },
  methods: {
    onSubmit() {
      this.nextCallBack(this.nextStep, this.answer, this.file);
    },
    inputFile($events: any) {
      const [files] = $events.target.files;
      const toLarge = files.size > MaxFileEnum.MAX_FILE;
      if (!toLarge) {
        this.file = files;
        this.fileWarnings = '';
      } else {
        this.fileWarnings = toLarge
          ? FileFieldEnum.MAX_VOLUME
          : FileFieldEnum.FILE_FORMAT;
        this.file = undefined;
      }
    },
  },
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ordersProcessForms/event/components/RequestRequirements.vue